import {ApiClient} from '@hconnect/apiclient'
import {AuthProvider} from '@hconnect/login'
import {hpTheme} from '@hconnect/uikit/src/lib2'
import {UpmPlantsProvider} from '@hconnect/upm'
import {
  FundamentalContextProvider,
  ThemeProvider as FundamentalThemeProvider,
  ToastContainer
} from '@hm/fundamental'
import {CssBaseline, ThemeProvider} from '@mui/material'
import {QueryClient, QueryClientProvider, DefaultOptions} from '@tanstack/react-query'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import {AxiosError} from 'axios'
import React from 'react'

import {ServiceWorkerProvider} from '../hooks/useServiceWorkerContext'

import {FundamentalThemeInitializer} from './FundamentalThemeInitializer'

interface GlobalProvidersProps {
  children: React.ReactNode
}

const isNetworkError = (error: AxiosError) => error.message === 'Network Error'
const retryTries = 1
const retryFunction = (failureCount: number, error: AxiosError): boolean =>
  failureCount < retryTries && isNetworkError(error)

const defaultOptions = {
  queries: {
    retry: retryFunction
  },
  mutations: {
    retry: retryFunction
  }
}

const queryClient = new QueryClient({
  defaultOptions: defaultOptions as DefaultOptions
})

export const GlobalProviders: React.FC<GlobalProvidersProps> = ({children}) => {
  return (
    <ServiceWorkerProvider>
      <FundamentalContextProvider>
        <FundamentalThemeProvider>
          <FundamentalThemeInitializer />
          <ThemeProvider theme={hpTheme}>
            <CssBaseline />
            <ToastContainer />
            <QueryClientProvider client={queryClient}>
              <AuthProvider>
                <UpmPlantsProvider api={ApiClient.axiosInstance}>
                  {children}
                  <ReactQueryDevtools initialIsOpen={false} />
                </UpmPlantsProvider>
              </AuthProvider>
            </QueryClientProvider>
          </ThemeProvider>
        </FundamentalThemeProvider>
      </FundamentalContextProvider>
    </ServiceWorkerProvider>
  )
}
